/* Reflect existing theme selection only. Never change selection or submit a form. */
(() => {
  'use strict';
  if (window.nciUpsellAccessibilityLoaded) return;
  window.nciUpsellAccessibilityLoaded = true;
  const selector = 'product-info-upsell[data-toggle="true"], cart-drawer-upsell[data-toggle="true"]';
  const sync = (component) => {
    const selected = component.getAttribute('data-selected');
    if (selected !== 'true' && selected !== 'false') return;
    component.querySelectorAll('button.upsell__toggle-switch, button.upsell__checkbox, button.upsell__plus-btn').forEach((button) => {
      button.setAttribute('aria-pressed', selected);
    });
  };
  const scan = (root) => {
    if (root.nodeType !== 1) return;
    if (root.matches(selector)) sync(root);
    root.querySelectorAll(selector).forEach(sync);
  };
  new MutationObserver((records) => {
    records.forEach((record) => {
      if (record.type === 'attributes') {
        if (record.target.matches(selector)) sync(record.target);
      } else {
        record.addedNodes.forEach(scan);
        const owner = record.target.closest(selector);
        if (owner) sync(owner);
      }
    });
  }).observe(document.documentElement, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['data-selected']
  });
  scan(document.documentElement);
})();
